import { render, staticRenderFns } from "./presaleUpgradePrice.vue?vue&type=template&id=3fc5b5d6&scoped=true&"
import script from "./presaleUpgradePrice.vue?vue&type=script&lang=js&"
export * from "./presaleUpgradePrice.vue?vue&type=script&lang=js&"
import style0 from "./presaleUpgradePrice.vue?vue&type=style&index=0&id=3fc5b5d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc5b5d6",
  null
  
)

export default component.exports